export const equipments_type_dry_van_enabled = true;
export const equipments_type_reefer_enabled = false;
export const equipments_type_flatbed_enabled = false;
export const equipments_type_power_only_enabled = true;